export const updateBalanceData = async () => {
    const balanceResponse = await fetch(routable.getRoute('getCompanyBalanceData'), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
    });

    const balance = await balanceResponse.json();

    await companyPaymentManager.tabs.payments.table.renderTotalBalanceBlock(balance['total']);
    await companyPaymentManager.tabs.payments.table.updateAccountBalancesPrototype(
        balance['balances']
    );
};
